export const FUTURES = 'futures';
